import { __read } from "tslib";
import React from 'react';
import { StyledProgressBar, StyledProgressBarFill } from './ProgressBar.styled';
import { StyledProgressBarMark } from './ProgressBarMarked.styled';
export var ProgressBarMarked = function (props) {
    var percent = props.percent, color = props.color, mark = props.mark, _a = props.showMark, showMark = _a === void 0 ? true : _a;
    var _b = __read(typeof mark === 'number' ? [mark, undefined] : mark, 2), position = _b[0], afterColor = _b[1];
    return (React.createElement(StyledProgressBar, null,
        React.createElement(StyledProgressBarFill, { percent: Math.min(position, percent), color: color, roundCorners: percent < position ? 'all' : 'left' }),
        React.createElement(StyledProgressBarFill, { percent: percent, start: position, color: afterColor, roundCorners: "right" }),
        showMark && React.createElement(StyledProgressBarMark, { position: position })));
};
//# sourceMappingURL=ProgressBarMarked.js.map